module.exports = __webpack_public_path__ + "static/media/IBANicon.93752fb6.png";